
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcBreadcrumb as ObcBreadcrumbElement} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
 import {BreadcrumbClickEvent} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
 export type {BreadcrumbClickEvent} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
 

 
 export const ObcBreadcrumb = createComponent({
   react: React,
   tagName: 'obc-breadcrumb',
   elementClass: ObcBreadcrumbElement,
   events: {
     
     onBreadcrumbClick: 'breadcrumb-click' as EventName<BreadcrumbClickEvent>,
   }
  });
 
 